module.exports = __webpack_public_path__ + "static/media/cht_3.f422c7a0.jpg";